import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { lazyWithRetry } from '../utils/lazyWithRetry';

// Lazy-loaded components
const SignIn = lazyWithRetry(() => import(/* webpackChunkName: "SignIn" */ "../pages/SignInPage"));
const SignUp = lazyWithRetry(() => import(/* webpackChunkName: "SignUp" */ "../pages/SignUpPage"));
const ForgotPassword = lazyWithRetry(() => import( /* webpackChunkName: "ForgotPassword" */ "../pages/ForgotPassword"));
const ForgotPasswordSuccess = lazyWithRetry(() => import(/* webpackChunkName: "ForgotPasswordSuccess" */ "../pages/ForgotPasswordSuccess"));
const ResetPassword = lazyWithRetry(() => import(/* webpackChunkName: "ResetPassword" */ "../pages/ResetPassword"));
const ResetPasswordSuccess = lazyWithRetry(() => import(/* webpackChunkName: "ResetPasswordSuccess" */ "../pages/ResetPasswordSuccess"));
const MultiFactorAuth = lazyWithRetry(() => import(/* webpackChunkName: "MultiFactorAuth" */ "../pages/MultiFactorAuth"));
const InviteUnavailable = lazyWithRetry(() => import(/* webpackChunkName: "InviteUnavailable" */ "../pages/InviteUnavailablePage"));
const AccessDeactivatedPage = lazyWithRetry(() => import(/* webpackChunkName: "AccessDeactivatedPage" */ "../pages/AccessDeactivatedPage"));
const NotFound = lazyWithRetry(() => import(/* webpackChunkName: "NotFound" */ "../pages/NotFound"));

interface AppRoutesProps {
    error?: any;
}

const AppRoutes: React.FC<AppRoutesProps> = ({ error }) => {
	return (
		<Suspense fallback={<div>Loading...</div>}>
			<Routes>
				<Route path="/" element={<SignIn error={error} />} />
				<Route path="/signin" element={<SignIn error={error} />} />
				<Route path="/signup" element={<SignUp error={error} />} />
				<Route path="/forgotpassword" element={<ForgotPassword error={error} />} />
				<Route path="/resetpassword" element={<ResetPassword error={error} />} />
				<Route path="/forgetPasswordSuccess" element={<ForgotPasswordSuccess />} />
				<Route path="/resetPasswordSuccess" element={<ResetPasswordSuccess />} />
				<Route path="/secure/otp-auth" element={<MultiFactorAuth error={error} />} />
				<Route path="/invite-unavailable" element={<InviteUnavailable />} />
				<Route path="/access-deactivated" element={<AccessDeactivatedPage />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</Suspense>
    );
}

export default AppRoutes;
